



















import Vue from "vue";
import { ROUTES } from "@tt-app/constants";

import LayoutFullCard from "@tt-app/layouts/LayoutFullCard.vue";

interface Computed {
  backDestination: {
    name: string;
  };
  breadcrumbs: string[];
}

interface Props {
  titleIcon: string;
  title: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "LegalDocLayout",
  components: { LayoutFullCard },

  props: {
    titleIcon: { type: String, required: true },
    title: { type: String, required: true }
  },

  computed: {
    backDestination() {
      return {
        name: ROUTES.USER.SETTINGS.NAME
      };
    },

    breadcrumbs() {
      return [this.$__("user.settings"), this.title];
    }
  }
});
